import * as React from "react";
import {
  Avatar,
  Backdrop,
  CircularProgress,
  Container,
  Grid,
  Link,
  Typography,
} from "@mui/material";
import DataGridComponent from "../../components/DataGridComponent";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DeleteOutline, Download, ModeEditOutlineOutlined } from "@mui/icons-material";
import { useTheme } from "@emotion/react";
import { toast } from "react-toastify";
import { deleteOrder, listOrders } from "../../actions/ordrActions";
import { ORDER_DELETE_RESET } from "../../constants/orderConstants";

export default function CategoryList() {
  const { palette } = useTheme();
  const columns = [
    {
      field: "customerName",
      width: 200,
      headerName: "CustomerName",
      renderCell: (params) => {
        return <> {params.row.customerName} </>;
      },
    },
    {
      field: "customerPhone",
      width: 200,
      headerName: "CustomerPhone",
      renderCell: (params) => {
        return <> {params.row.customerPhone} </>;
      },
    },
    {
      field: "customerAddress",
      headerName: "CustomerAddress",
      width: 150,
      renderCell: (params) => {
        return <>{params.row.customerAddress}</>;
      },
    },
    {
      field: "discount",
      width: 200,
      headerName: "Discount",
      renderCell: (params) => {
        return <> {params.row.discount} </>;
      },
    },
    {
      field: "totalPrice",
      width: 200,
      headerName: "TotalPrice",
      renderCell: (params) => {
        return <> {params.row.totalPrice} </>;
      },
    },
    {
      field: "paid",
      headerName: "Is Paid",
      width: 200,
      renderCell: (params) => {
        return (
          <>
            {" "}
            {params.row.paid ? (
              <Typography variant="body2" color="primary">
                Paid
              </Typography>
            ) : (
              <Typography variant="body2" color="red">
                Not Paid
              </Typography>
            )}
          </>
        );
      },
    },

    {
      field: "shipped",
      headerName: "Is Shipped",
      width: 200,
      renderCell: (params) => {
        return (
          <>
            {" "}
            {params.row.shipped ? (
              <Typography variant="body2" color="primary">
                Shipped
              </Typography>
            ) : (
              <Typography variant="body2" color="red">
                Not Shipped
              </Typography>
            )}
          </>
        );
      },
    },

    {
      field: "orderItems",
      width: 800,
      headerName: "Product ordered",
      renderCell: (params) => {
        return (
          <Container sx={{}}>
            {" "}
            {params.row.orderItems.map(
              (item) => (
                <>
                  {item.product &&
                    item.product.name +
                      " " +
                      "Quantity: " +
                      item.qty +
                      " " +
                      "Price: " +
                      " " +
                      item.price}
                </>
              )
              //add line break after each product
            )}{" "}
          </Container>
        );
      },
    },

    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <>
            <Link href={`/order/${params.row._id}`}>
              <ModeEditOutlineOutlined
                style={{
                  color: palette.primary.main,
                  cursor: "pointer",
                  marginRight: "10px",
                }}
              />
            </Link>
            <DeleteOutline
              className="delIcon"
              sx={{
                cursor: "pointer",
                color: palette.error.main,
              }}
              onClick={() => handleDelete(params.row._id)}
            />
            
            <Link href={`/order/invoice/${params.row._id}`}>
              <Download
              titleAccess="Download Invoice"
                style={{
                  color: palette.primary.main,
                  cursor: "pointer",
                  marginRight: "10px",
                }}
              />
            </Link>
          </>
        );
      },
    },
  ];

  const dispatch = useDispatch();

  const orderList = useSelector((state) => state.orderList);
  const { loading, error, orders } = orderList;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const orderDelete = useSelector((state) => state.orderDelete);
  const { success } = orderDelete;

  React.useEffect(() => {
    dispatch(listOrders());
    if (!userInfo) {
      navigate("/", { replace: true });
    }
    if (success) {
      toast("Order deleted successfully");
      dispatch({ type: ORDER_DELETE_RESET });
    }
  }, [dispatch, userInfo, success]);

  const navigate = useNavigate();

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete the order?")) {
      dispatch(deleteOrder(id));
    }
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        {loading && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}

        {error && (
          <Typography variant="h6" color="error">
            {error}
          </Typography>
        )}

        {orders && (
          <DataGridComponent
            buttonTitle={"Add order"}
            onClick={() => navigate("/addOrder")}
            title={"Order List"}
            columns={columns}
            rows={orders}
          />
        )}
      </Grid>
    </Grid>
  );
}
